import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "COMPLETION",
  title: defineMessage({
    id: "fig.access.COMPLETION.title",
    defaultMessage: `Timely and ultimate cohort completion rate by level`,
  }),
  caption: defineMessage({
    id: "fig.access.COMPLETION.caption",
    defaultMessage: "Many children complete school late",
  }),
  source: defineMessage({
    id: "fig.access.COMPLETION.source",
    defaultMessage: "GEM Report team analysis using household survey data",
  }),
};
